import React from 'react';
import TopBar from './components/TopBar';
import Navbar from './components/NavBar';
import Banner from './components/Banner';
import About from './components/About';
import Services from './components/Services';
import CorporateRelocation from './components/CorporateRelocation';
import Footer from './components/Footer';

function App() {
  return (
    <div>
      <TopBar />
      <Navbar />
      <Banner />
      <About />
      <CorporateRelocation />
      <Footer />
    </div>
  );
}

export default App;
